import * as React from 'react';
import { clsx } from 'clsx';

import * as styles from './LocationModalItem.css';
import { TextHighlighter } from '../TextHighlighter';

interface ILocationItemProps {
  bold?: boolean;
  children: string;
  matches?: [number, number][];
  onClick?: () => void;
}

export const LocationModalItem: React.FC<ILocationItemProps> = ({ bold = false, children, matches, onClick }) => {
  return (
    <li className={clsx(styles['item'], { [styles['bold']]: bold })} role="option" tabIndex={-1} onClick={onClick}>
      <TextHighlighter text={children} matches={matches} />
    </li>
  );
};
